<template>
  <vx-card :title="id === null ? 'Cadastrar Usuário' : 'Editar Usuário'">
    <vs-tabs :color="colorx">
      <vs-tab label="Usuário">
        <validation-observer ref="formobserver">
          <b-form @submit.prevent="create">
            <div class="vx-row">
              <div class="vx-col w-full">
                <b-form-group label="Nome" label-for="userName">
                  <validation-provider
                    #default="{ errors }"
                    name="Nome"
                    rules="required"
                  >
                    <b-form-input
                      id="userName"
                      v-model="userName"
                      :state="errors.length > 0 ? false : null"
                      name="userName"
                      class="required"
                    />
                    <b-form-invalid-feedback>
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col w-full">
                <b-form-group label="E-mail" label-for="surname">
                  <validation-provider
                    #default="{ errors }"
                    name="E-mail"
                    rules="required|email"
                  >
                    <b-form-input
                      id="email"
                      v-model="userEmail"
                      :state="errors.length > 0 ? false : null"
                      name="email"
                      class="required"
                    />
                    <b-form-invalid-feedback>
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </div>
            </div>

            <div class="vx-row mt-3">
              <div class="vx-col w-full">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-secondary"
                  @click="cancel"
                  class="mt-5 float-right"
                >
                  Voltar
                </b-button>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="mt-5 mr-2 float-right"
                  :disabled="!validateForm"
                  type="submit"
                >
                  Salvar
                </b-button>
              </div>
            </div>
          </b-form>
        </validation-observer>
      </vs-tab>
      <vs-tab label="Grupos" v-if="id !== null">
        <div class="vx-row mb-6" style="padding-top: 30px">
          <div class="vx-col w-full">
            <div class="flex justify-end">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-2"
                @click="showModal = true"
              >
                <feather-icon icon="PlusIcon" class="mr-50" />
                <span class="align-middle">{{ $t('add') }}</span>
              </b-button>
              <b-button
                variant="outline-secondary"
                class="float-right"
                @click="cancel"
              >
                <feather-icon icon="CornerUpLeftIcon" class="mr-50" />
                <span class="align-middle">{{ $t('back') }}</span>
              </b-button>
            </div>
            <vs-divider />
            <Grid
              ref="grid"
              :service="roleService"
              route_name="roles"
              :route_grid_path="userRolesPath"
              :route_delete_path="userRolesPath"
              hide_edit="true"
              :delegate="{ destroy: () => destroyRoleUser }"
            ></Grid>
          </div>
        </div>
      </vs-tab>
    </vs-tabs>

    <vs-popup title="Grupos" :active.sync="showModal">
      <Grid
        :service="roleService"
        :delegate="{ itemSelected: () => itemSelected }"
        route_name="/roles"
        v-if="showModal"
        hide_actions="true"
      ></Grid>
    </vs-popup>
  </vx-card>
</template>

<script>
import UserService from '@/services/api/UserService'
import RoleService from '@/services/api/RoleService'

import {
  BForm,
  BButton,
  BFormInput,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BFormInvalidFeedback
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

export default {
  components: {
    BForm,
    BButton,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    // Validation
    ValidationProvider,
    ValidationObserver,
    BFormInvalidFeedback
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    id: null,
    userEmail: '',
    userName: '',
    roleService: null,
    showModal: false,
    // validation rules
    required
  }),
  computed: {
    colorx() {
      return 'primary'
    },
    userRolesPath() {
      return `/user/${this.id}`
    },
    validateForm() {
      return this.userEmail !== '' && this.userName !== ''
    }
  },
  methods: {
    itemSelected(role) {
      if (role) {
        this.$vs.loading()
        this.roleService.attachRoleUser(role.id, this.id).then(
          response => {
            this.$vs.loading.close()
            this.notifySuccess(this.$vs)

            if ('grid' in this.$refs) {
              this.$refs.grid.fetchGridData()
            }
          },
          error => {
            this.$vs.loading.close()
            this.notifyError(this.$vs, 'Não foi possível incluir este grupo!')
          }
        )
      }
      this.showModal = false
    },
    destroyRoleUser(role) {
      this.$vs.loading()
      return this.roleService.destroyRoleUser(role.id, this.id).then(
        response => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Successo!',
            text: 'Operação realizada com sucesso.',
            color: 'success',
            iconPack: 'feather',
            position: 'top-center',
            icon: 'icon-check-circle'
          })

          return { reload: true }
        },
        error => {
          this.$vs.loading.close()
          this.notifyError(this.$vs, 'Não foi possível escluir este grupo!')
        }
      )
    },
    create() {
      this.clearErrors(this.$refs.formobserver)
      this.$vs.loading()

      const userService = UserService.build(this.$vs)
      let promise = null

      const data = {
        email: this.userEmail,
        name: this.userName
      }

      if (this.isEmpty(this.id)) {
        promise = userService.internalStore(data)
      } else {
        data['id'] = this.id
        promise = userService.update(data)
      }

      promise.then(
        data => {
          this.id = data.id
          this.$vs.loading.close()

          this.notifySuccess(this.$vs)

          this.$router.push(`/users/${data.id}/edit`)
        },
        error => {
          this.$vs.loading.close()
          this.showErrors(this.$refs.formobserver, error, this)
        }
      )
    },
    cancel() {
      this.$router.push('/users')
    },
    getData(id) {
      this.$vs.loading()
      const service = UserService.build(this.$vs)
      service.read(id).then(
        data => {
          this.$set(this.$data, 'id', data.id)
          this.$set(this.$data, 'userEmail', data.email)
          this.$set(this.$data, 'userName', data.name)

          this.$vs.loading.close()
        },
        error => {
          this.$vs.loading.close()
        }
      )
    }
  },
  created() {
    this.roleService = RoleService.build(this.$vs)
    if (this.id) {
      this.getData(this.id)
    }
  },
  beforeMount() {},
  mounted() {},
  beforeDestroy() {}
}
</script>
